<!-- Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied. -->
<template>
  <v-layout v-scroll="onScroll">
    <v-flex
      class="sidebar"
      px-3
      pt-4
      d-block
      fill-height>
      <v-list
        :style="fixedStyle + ' min-width: 218px; background: rgba(0,0,0,0);'"
        dense>
        <v-list-tile
          exact
          ripple
          to="/help">
          <v-list-tile-content>
            <b class="title grey--text text--darken-2">DartCannon Help</b>
          </v-list-tile-content>
        </v-list-tile>
        <template v-for="page in pages">
          <v-list-group
            v-if="page.children.length"
            no-action
            :key = "page.id"
            :group="page.id">
            <v-list-tile
              slot = "activator"
              ripple>
              <v-list-tile-content class="subheading">{{ page.title }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for= "child in page.children"
              :key ="child.id"
              :to = "child.url"
              ripple>
              <v-list-tile-content class="subheading">{{ child.title }}</v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
            v-else
            ripple
            :to = "page.url"
            :key = "page.id">
            <v-list-tile-content>
              <v-list-tile-title class="subheading">{{ page.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-flex>
    <v-flex
      d-flex
      fill-height>
      <router-view
        :scroll-style="fixedStyle"
        :current-offset="currentOffset"
        base="/help"/>
    </v-flex>
  </v-layout>
</template>
<script>
import * as VGrid from 'vuetify/es5/components/VGrid'
import * as VList from 'vuetify/es5/components/VList'
import { Scroll } from 'vuetify/es5/directives'
// import { pages as oldPages} from '@/docs/help'
import { pages } from '@/docs/help.val'

export default {
  data () {
    return {
      currentOffset: 0,
      position:      'relative',
      right:         0,
      top:           0,
    }
  },
  computed: {
    fixedStyle () {
      return `position: ${this.position}; top: ${this.top}px;`
    },
    pages () {
      return pages.sort((a, b) => a.weight - b.weight)
    },
  },
  methods: {
    onScroll () {
      this.currentOffset = window.pageYOffset || document.documentElement.offsetTop
      const float = this.currentOffset >= 24
      this.top = float ? 85 : 0
      this.position = float ? 'fixed' : 'relative'
    },
  },
  components: {
    ...VGrid,
    ...VList,
  },
  directives: {
    Scroll,
  },
}
</script>
<style>
.sidebar {
  flex: 0 1;
  min-width: 250px;
}

.v-list__group__items--no-action .v-list__tile {
  padding-left: 42px;
}
</style>
